<template>
  <div class="pc-tabbar-container">
    <div class="inner-container">
      <div class="public-content">
        <div class="logo-item img-contain"><img v-if="websiteInfo.Logo" :src="websiteInfo.Logo" /></div>
        <div class="nav-list-item">
          <router-link :to="{path: '/'}" class="nav-item" :class="tabBarKey == 'home' ? 'active' : ''">首页</router-link>
          <router-link v-if="userInfo && userInfo.Id" :to="{path: '/order'}" class="nav-item" :class="tabBarKey == 'order' ? 'active' : ''">订单</router-link>
          <div v-else class="nav-item" @click="handleShowLogin">订单</div>
          <router-link :to="{path: '/goodsIsBo'}" class="nav-item" :class="tabBarKey == 'goodsIsBo' ? 'active' : ''">流量领取</router-link>
        </div>
        <div v-if="tabBarKey == 'home'" class="search-item">
          <div class="input-item"><input v-model="searchKey" type="text" placeholder="输入要搜索的内容" /></div>
          <div class="btn-item" @click="handlesearch"><img class="icon" src="../assets/pc-images/search-icon.png" /></div>
        </div>
        <router-link v-if="userInfo && userInfo.Id" class="userinfo-item" :to="{path: '/user'}">
          <div class="header-item img-cover">
            <img v-if="userInfo.Header" :src="userInfo.Header" />
            <img v-else src="../assets/images/default-header.png" />
          </div>
        </router-link>
        <div v-else class="login-btn" @click="handleShowLogin">登录/注册</div>
      </div>
    </div>
    <el-dialog v-if="dialog.login" :visible.sync="dialog.login" custom-class="login-dialog" destroy-on-close>
      <pcLoginComponent @onLoginSuccess="onLoginSuccess" />
    </el-dialog>
  </div>
</template>

<script>
import pcLoginComponent from './pcLoginComponent.vue'
import { mapState } from 'vuex'
export default {
  emits: ['onSearch'],
  name: 'PcTabBarComponent',
  props: {
    tabBarKey: String
  },
  components: {
    pcLoginComponent
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  data() {
    return {
      searchKey: '',
      dialog: {
        login: false
      }
    }
  },
  methods: {
    handlesearch() {
      this.$emit('onSearch', this.searchKey)
    },
    onLoginSuccess() {
      this.dialog.login = false
    },
    handleShowLogin() {
      this.dialog.login = true
    }
  }
}
</script>

<style scoped lang="less">
.pc-tabbar-container {
  width: 100%;
  height: 80px;
  .inner-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    min-width: 1200px;
    background-color: #fff;
    box-shadow: -4px 0 10px 0 rgba(87, 131, 252, .25);
    z-index: 20;
    .public-content {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .logo-item {
      width: 120px;
      height: 50px;
    }
    .nav-list-item {
      flex: 1;
      display: flex;
      align-items: center;
      padding-left: 55px;
      .nav-item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        font-size: 14px;
        font-weight: 500;
        color: #000;
        position: relative;
        margin-right: 55px;
        &.active::after,
        &:hover::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 4px;
          border-radius: 2px;
          background-color: #5783fc;
        }
      }
    }
    .search-item {
      width: 263px;
      height: 48px;
      border: 1px solid #e5e5e5;
      border-radius: 25px;
      display: flex;
      align-items: center;
      margin-right: 30px;
      &:hover {
        border-color: #5783fc;
      }
      .input-item {
        height: 36px;
        padding-left: 24px;
        flex: 1;
      }
      .btn-item {
        margin-right: 10px;
        width: 75px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 18px;
        background-color: #5783fc;
        cursor: pointer;
        &:active {
          background-color: #2563eb;
        }
        .icon {
          width: 16px;
          height: 16px;
        }
      }
    }
    .userinfo-item {
      .header-item {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
      } 
    }
    .login-btn {
      width: 100px;
      height: 36px;
      border-radius: 18px;
      background-color: #5783fc;
      color: #fff;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
      &:active {
        background-color: #2563eb;
      }
      &:hover {
        box-shadow: -4px 0 10px 0 rgba(87, 131, 252, .25);
      }
    }
  }
}
/deep/.login-dialog {
  width: 750px;
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__headerbtn {
    top: 5px;
    right: 5px;
    width: 15px;
    height: 15px;
    i {
      display: block;
    }
  }
}
</style>